import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c94f54a4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=c94f54a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94f54a4",
  null
  
)

export default component.exports